import { gql } from "@apollo/client";


export const CREATE_IMAGE_MUTATION = gql`
    mutation CreateImage($input: ImageInput!) { 
        createImage(input: $input) { 
            url 
        } 
    }`;
